export default __webpack_public_path__ + "static/media/goopter-flashbot-building-delivery-spec.bf4931ea.jpeg";